
      <div class="row">

          <!--  SLIDER CONTROL  -->

          <div class="slider-container col-sm1-30" [ngClass]="{'col-sm3-16 has-text-input' : textInput}">

              <!--  MATERIAL SLIDER CONTROL  -->

              <mat-slider [value]="sliderValue"
                          [min]="min"
                          [max]="max"
                          [step]="step"
                          [invert]="invert"
                          [thumbLabel]="thumbLabel"
                          [tickInterval]="tickInterval"
                          (input)="onSliderInput($event)">
              </mat-slider>

              <!-- END MATERIAL SLIDER CONTROL  -->

          </div>

          <!-- END SLIDER CONTROL  -->

          <!-- DIRECT INPUT CONTROL  -->

          <div class="slider-input-container col-sm1-30 col-sm3-14" [class.hidden]="!textInput">
              <div class="input-group control"
                   [class.focus]="isInFocus"
                   [class.has-suffixes]="controlSuffixes.length > 0"
                   [formGroup]="form">

                  <!--  PREFIXES  -->

                  <ng-template ngFor let-prefix [ngForOf]="controlPrefixes">

                      <span class="prefix" [ngClass]="{'is-link pri-bg pri-mix-hov-bg pri-bd pri-mix-hov-bd' : prefix.event}">
                          <i *ngIf="prefix.icon" [ngClass]="prefix.icon"></i>
                          {{ prefix.text }}
                      </span>

                  </ng-template>

                  <!--  END PREFIXES  -->

                  <!--  INPUT  -->

                  <div>
                      <input type="number"
                             [id]="id"
                             [formControlName]="name"
                             [min]="min"
                             [max]="max"
                             [step]="step"
                             (input)="onTextInput()"
                             (focus)="isInFocus = true"
                             (blur)="isInFocus = false"/>
                  </div>

                  <!--  END INPUT -->

                  <!--  SUFFIXES  -->

                  <ng-template ngFor let-suffix [ngForOf]="controlSuffixes">

                      <span class="suffix" [class.last-child]="i === controlSuffixes.length - 1" [ngClass]="{'is-link pri-bg pri-fg-col pri-mix-hov-bg pri-bd pri-mix-hov-bd' : suffix.event}">
                          <i *ngIf="suffix.icon" [ngClass]="suffix.icon"></i>
                          {{ suffix.text }}
                      </span>

                  </ng-template>

                  <!-- END SUFFIXES  -->

              </div>
          </div>

          <!-- END DIRECT INPUT CONTROL  -->

      </div>
    